define(["exports", "./utils", "hyperhtml", "text!../../assets/mdn-annotation.css"], function (_exports, _utils, _hyperhtml, _mdnAnnotation) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;
  _hyperhtml = _interopRequireDefault(_hyperhtml);
  _mdnAnnotation = _interopRequireDefault(_mdnAnnotation);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _templateObject5() {
    const data = _taggedTemplateLiteral(["<script>\n     function toggleMDNStatus(div) {\n       div.parentNode.classList.toggle('wrapped');\n     }\n  </script>"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    const data = _taggedTemplateLiteral(["<style>", "</style>"]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    const data = _taggedTemplateLiteral(["<p class=\"mdnsupport\">\n    ", "\n  </p>"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    const data = _taggedTemplateLiteral(["\n      <a title=\"", "\" href=\"", "\">", "</a>\n  "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    const data = _taggedTemplateLiteral(["<aside class=\"mdn before wrapped\"></aside>"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

  const name = "core/mdn-annoatation";
  _exports.name = name;
  const SPEC_MAP_URL = "https://raw.githubusercontent.com/w3c/mdn-spec-links/master/SPECMAP.json";
  const BASE_JSON_PATH = "https://w3c.github.io/mdn-spec-links/";
  const MDN_URL_BASE = "https://developer.mozilla.org/en-US/docs/Web/";
  const MDN_BROWSERS = {
    // The browser IDs here must match the ones in the imported JSON data.
    // See the list of browser IDs at https://goo.gl/iDacWP.
    chrome: "Chrome",
    chrome_android: "Chrome Android",
    edge: "Edge",
    edge_mobile: "Edge Mobile",
    firefox: "Firefox",
    firefox_android: "Firefox Android",
    ie: "Internet Explorer",
    // nodejs: "Node.js", // no data for features in HTML
    opera: "Opera",
    opera_android: "Opera Android",
    // qq_android: "QQ Browser", // not enough data for features in HTML
    safari: "Safari",
    safari_ios: "Safari iOS",
    samsunginternet_android: "Samsung Internet",
    // uc_android: "UC browser", // not enough data for features in HTML
    // uc_chinese_android: "Chinese UC Browser", // not enough data for features in HTML
    webview_android: "WebView Android"
  };

  function fetchAndCacheJson(url, maxAge) {
    if (!url) return {};
    return (0, _utils.fetchAndCache)(url, maxAge).then(r => r.json());
  }

  function insertMDNBox(node) {
    const targetAncestor = node.closest("section");
    const {
      previousElementSibling: targetSibling,
      parentNode
    } = targetAncestor;

    if (targetSibling && targetSibling.classList.contains("mdn")) {
      // If the target ancestor already has a mdnBox inserted, we just use it
      return targetSibling;
    }

    const mdnBox = (0, _hyperhtml.default)(_templateObject());
    parentNode.insertBefore(mdnBox, targetAncestor);
    return mdnBox;
  }

  function attachMDNDetail(container, mdnSpec) {
    const {
      slug,
      summary
    } = mdnSpec;
    container.innerHTML += "<button onclick=\"toggleMDNStatus(this.parentNode)\" aria-label=\"Expand MDN details\"><b>MDN</b></button>";
    const mdnSubPath = slug.slice(slug.indexOf("/") + 1);
    const mdnDetail = document.createElement("div");
    const href = "".concat(MDN_URL_BASE).concat(slug);
    (0, _hyperhtml.default)(mdnDetail)(_templateObject2(), summary, href, mdnSubPath);
    attachMDNBrowserSupport(mdnDetail, mdnSpec);
    container.appendChild(mdnDetail);
  }

  function attachMDNBrowserSupport(container, mdnSpec) {
    if (!mdnSpec.support) {
      container.innerHTML += "<p class=\"nosupportdata\">No support data.</p>";
      return;
    }

    const supportTable = (0, _hyperhtml.default)(_templateObject3(), [buildBrowserSupportTable(mdnSpec.support)]);
    container.appendChild(supportTable);
  }

  function buildBrowserSupportTable(support) {
    let innerHTML = "";

    function addMDNBrowserRow(browserId, yesNoUnknown, version) {
      const displayStatus = yesNoUnknown === "Unknown" ? "?" : yesNoUnknown;
      const classList = "".concat(browserId, " ").concat(yesNoUnknown.toLowerCase());
      const browserRow = "\n      <span class=\"".concat(classList, "\">\n        <span class=\"browser-name\">").concat(MDN_BROWSERS[browserId], "</span>\n        <span class=\"version\">").concat(version ? version : displayStatus, "</span>\n      </span>");
      innerHTML += browserRow;
    }

    function processBrowserData(browserId, versionData) {
      if (versionData.version_removed) {
        addMDNBrowserRow(browserId, "No", "");
        return;
      }

      const versionAdded = versionData.version_added;

      if (!versionAdded) {
        addMDNBrowserRow(browserId, "Unknown", "");
        return;
      }

      if (typeof versionAdded === "boolean") {
        addMDNBrowserRow(browserId, versionAdded ? "Yes" : "No", "");
      } else {
        addMDNBrowserRow(browserId, "Yes", "".concat(versionAdded, "+"));
      }
    }

    Object.keys(MDN_BROWSERS).forEach(browserId => {
      if (!support[browserId]) {
        addMDNBrowserRow(browserId, "Unknown", "");
      } else {
        if (Array.isArray(support[browserId])) {
          support[browserId].forEach(b => {
            processBrowserData(browserId, b);
          });
        } else {
          processBrowserData(browserId, support[browserId]);
        }
      }
    });
    return innerHTML;
  }

  async function run(conf) {
    const {
      shortName,
      mdn
    } = conf;

    if (!shortName || !mdn) {
      // Nothing to do if shortName is not provided
      return;
    }

    const maxAge = mdn.maxAge || 60 * 60 * 24 * 1000;
    const specMapUrl = mdn.specMapUrl || SPEC_MAP_URL;
    const baseJsonPath = mdn.baseJsonPath || BASE_JSON_PATH;
    const specMap = await fetchAndCacheJson(specMapUrl, maxAge);
    const hasSpecJson = Object.values(specMap).some(jsonName => jsonName === "".concat(shortName, ".json"));

    if (!hasSpecJson) {
      return;
    }

    const mdnSpecJson = await fetchAndCacheJson("".concat(baseJsonPath, "/").concat(shortName, ".json"), maxAge);
    document.head.appendChild((0, _hyperhtml.default)(_templateObject4(), [_mdnAnnotation.default]));
    document.head.appendChild((0, _hyperhtml.default)(_templateObject5()));
    const nodesWithId = document.querySelectorAll("[id]");
    [...nodesWithId].filter(node => {
      const unlikelyTagNames = ["STYLE", "SCRIPT", "BODY"];
      return unlikelyTagNames.indexOf(node.tagName) === -1 && mdnSpecJson[node.id] && Array.isArray(mdnSpecJson[node.id]);
    }).forEach(node => {
      const mdnSpecArray = mdnSpecJson[node.id];
      const mdnBox = insertMDNBox(node);
      mdnSpecArray.map(spec => {
        const mdnDiv = document.createElement("div");
        attachMDNDetail(mdnDiv, spec);
        return mdnDiv;
      }).forEach(mdnDiv => mdnBox.appendChild(mdnDiv));
    });
  }
});
//# sourceMappingURL=mdn-annotation.js.map